/**
 * MyGemaPro APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface EquipmentMaintenanceTimerConfigDto { 
    timerType: EquipmentMaintenanceTimerConfigDto.TimerTypeEnum;
    durationDays: number;
    reminderDurationDays: number;
    earlyToleranceDays: number;
    lateToleranceDays: number;
    imagesMandatory: boolean;
}
export namespace EquipmentMaintenanceTimerConfigDto {
    export type TimerTypeEnum = 'Maintenance' | 'Inspection' | 'SelfInspection' | 'Warranty';
    export const TimerTypeEnum = {
        Maintenance: 'Maintenance' as TimerTypeEnum,
        Inspection: 'Inspection' as TimerTypeEnum,
        SelfInspection: 'SelfInspection' as TimerTypeEnum,
        Warranty: 'Warranty' as TimerTypeEnum
    };
}


